<div class="container">
  <app-generic-question
    style="width: 100%"
    [bodyQuestions]="bodyQuestions"
    (questionAdded)="addNewQuestion()"
    (questionDeleted)="deleteQuestion($event)"
    (questionEdited)="editQuestion($event)"
  ></app-generic-question>
</div>
